import React from 'react';
import Icon from '@xo-union/tk-component-icons';
import { DisplayButton } from '@xo-union/tk-ui-links';
import styles from './styles.scss';

interface AddGuestButtonProps {
  onClick: () => void;
}

const AddGuestButton: React.FC<AddGuestButtonProps> = ({ onClick }) => (
  <DisplayButton className={styles.button} onClick={onClick} color="primary" size="lg">
    <Icon className={styles.icon} name="add_circle" size="md" />
    <span className={styles.text}>Add a Guest to this Party</span>
  </DisplayButton>
);

export default AddGuestButton;
